export default {
  state: {
    info: null,
    userNavBarImg:'',
  },
  actions: {
    setPlatformInfo: function (context, info) {
      context.state.info = info
    },
    setUserNavBarImg: function (context, img) {
      context.state.userNavBarImg = img
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/platform/index.js